import ContactInfo from "../profile/contact";
import SocialMedia from "../profile/socialmedia";

export default function AboutTab() {
  return (
    <div className="h-full">
      <div className="space-y-6 h-full p-1 md:p-4">
        <ContactInfo />
        <SocialMedia />
      </div>
    </div>
  )
}

